import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ConfirmService {
  constructor(private confirmationService: ConfirmationService) {}

  confirm(
    event: any,
    confirmObj: { accept: Function; key?: string; message?: string }
  ) {
    this.confirmationService.confirm({
      target: event.target,
      key: confirmObj.key ? confirmObj.key : undefined,
      message: confirmObj.message
        ? confirmObj.message
        : 'Are you sure you want to remove this item?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      accept: () => {
        confirmObj.accept();
      },
    });
  }
}
